const initialState = {
  goals: null,
};

export const sellerGoals = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_GOALS":
      return { goals: action.payload };
    case "UPDATE_SELLER_GOALS":
      return { goals: action.payload };
    default:
      return state;
  }
};
